<template>
    <div v-if="isFirefoxBrowser" class="visually-hidden" id="accessible-btn-wrapper">
        <previous-button
            @previousStep="() => { $emit('previousStep') }"
        />
        <next-button
            :aria-label="ariaLabel"
            :aria-disabled="disabled"
            :data-testid="`place-continue-${index}`"
            @nextStep="onClick"
        />
    </div>
</template>

<script>
import { isFirefox } from '@/utils';
import PreviousButton from '@/components/buttons/PreviousButton.vue';
import NextButton from '@/components/buttons/NextButton.vue';

export default {
    name: 'firefox-a11y-place',
    components: {
        PreviousButton,
        NextButton
    },
    props: {
        place: { type: Object, required: true },
        index: { type: Number, required: true },
        disabled: { type: Boolean, required: true },
        ariaLabel: { type: String, required: true },
    },
    methods: {
        onClick() {
            this.$emit('onClick');
        },
    },
    computed: {
        isFirefoxBrowser() {
            return isFirefox();
        },
    },
};

</script>
